import {
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  SHOW_TOAST,
  CLOSE_TOAST,
  GET_USER_PROFILE,
  SET_ACTIVE_TAB,
  SET_VISITED_COURSE_ID,
  SET_COMMON_STORE_PARAM,
  SET_FEATURE_FLAGS,
} from 'actions/admin/auth';

const initialState = {
  loggedUser: {},
  loggedUserToken: '',
  loggedUserId: 0,
  loggedUserRole: '',
  loggedUserSchool: '',
  loggedUserEmail: '',
  // Per-user feature switches (name -> value) and whether they have been read for this login yet.
  featureFlags: {},
  featureFlagsLoaded: false,
  toast: {
    show: false,
    errorType: '',
    message: '',
  },
  userProfile: {},
  activeTab: 0,
  visitedCourseIds: {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
  },
  // Common params
  dashboardActiveTab: 0,
  actvitiesActiveTab: 0,
  schooActiveTab: 0,
  studentActiveTab: 0,
  // 'schoolStudent' | 'courseStudent' | 'myStudent' - which of the Students tab's own subtabs
  // (Batch Students / Class Students / My Class Students) was last selected.
  studentListApiType: 'schoolStudent',
  appThemeActiveTab: 0,
  isDragDialogOpen: false,
};

export default function auth(state = initialState, action = {}) {
  switch (action.type) {
    case USER_LOGGED_IN: {
      return {
        ...state,
        loggedUser: action.user,
        loggedUserToken: action.user.accessToken,
        loggedUserId: action.user.referenceId,
        loggedUserRole: action.user.userRole,
        loggedUserSchool: action.user.schoolId,
        loggedUserEmail: action.user?.email,
        featureFlags: {},
        featureFlagsLoaded: false,
      };
    }
    case USER_LOGGED_OUT:
      return {
        ...state,
        loggedUser: {},
        loggedUserToken: '',
        loggedUserId: 0,
        loggedUserRole: '',
        loggedUserSchool: '',
        featureFlags: {},
        featureFlagsLoaded: false,
      };
    case SET_FEATURE_FLAGS:
      return { ...state, featureFlags: action.flags || {}, featureFlagsLoaded: true };
    case SHOW_TOAST: {
      return {
        ...state,
        toast: {
          show: true,
          errorType: action.errorType,
          message: action.message,
        },
      };
    }
    case CLOSE_TOAST: {
      return { ...state, toast: initialState.toast };
    }
    case GET_USER_PROFILE: {
      return { ...state, userProfile: action.userProfile };
    }
    case SET_ACTIVE_TAB: {
      return { ...state, activeTab: action?.activeTab };
    }
    case SET_VISITED_COURSE_ID: {
      return { ...state, visitedCourseIds: { ...state.visitedCourseIds, [action?.activeTab]: action?.courseId || 0 } };
    }
    case SET_COMMON_STORE_PARAM: {
      return {
        ...state,
        [action.paramName]: action.value,
      };
    }
    default:
      return state;
  }
}
